var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.5 86.2",
    style: {
      enableBackground: "new 0 0 87.5 86.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DC2E2E;}\n\t.st1{fill:#F7F8FC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.6,33c-1,0-1.9-0.4-2.6-1.1c-0.7-0.7-1.1-1.6-1.1-2.6V5.5h-1.8V1.8h9.2V0h11v1.8h9.2v3.7h-1.8v23.8 c0,1-0.4,1.9-1.1,2.6c-0.7,0.7-1.6,1.1-2.6,1.1H34.6z M38.2,25.7h3.7V9.2h-3.7V25.7z M45.6,25.7h3.7V9.2h-3.7V25.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.6,42.5v40.6h12.5V55h31.2v28.1h12.5V42.5H15.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.4,80H75V45.6h1.6c2.1,0,4-1,5.2-2.7c1.2-1.7,1.4-3.9,0.6-5.8l-4.5-11.3c-0.5-1.2-1.6-2-2.9-2h-6.2 c-1.7,0-3.1,1.4-3.1,3.1S67,30,68.8,30h4.1l3.7,9.4h-4.8l-56.2,0c0,0,0,0,0,0s0,0,0,0h-4.7l3.7-9.4h4.1c1.7,0,3.1-1.4,3.1-3.1 s-1.4-3.1-3.1-3.1h-6.2c-1.3,0-2.4,0.8-2.9,2L5.1,37.1c-0.8,1.9-0.5,4.1,0.6,5.8c1.2,1.7,3.1,2.7,5.2,2.7h1.6V80H3.1 C1.4,80,0,81.4,0,83.1s1.4,3.1,3.1,3.1h81.2c1.7,0,3.1-1.4,3.1-3.1S86.1,80,84.4,80z M18.8,45.6h50V80h-6.2V55 c0-1.7-1.4-3.1-3.1-3.1H28.1c-1.7,0-3.1,1.4-3.1,3.1v25h-6.2V45.6z M56.2,80h-25V58.1h25V80z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteStore);
export default __webpack_public_path__ + "static/media/icon_delete_store.5195edd193e6f830cd5a98b3486e8487.svg";
export { ForwardRef as ReactComponent };